export default __webpack_public_path__ + "static/media/not-found.b6105ffd.svg";